module.exports = __webpack_public_path__ + "a7acab2c1f5395893704084a2e062e0a.svg";